import React from "react";
import { ToastContainer } from "react-toastify";
import MeetingScheduler from "./MeetingScheduler";
import "./Contact.scss";

const Contact = () => {
  return (
    <div className="contact-page-hero">
      <ToastContainer position="top-right" autoClose={5000} />

      <div className="contact-page-container">
        <div className="contact-page-header">
          <span className="contact-page-badge">Get In Touch</span>
          {/* <h1 className="contact-page-title">Connect with Brooks Container</h1>
          <p className="contact-page-subtitle">
            Schedule a convenient 30-minute meeting with our investment team or reach out to us directly.
          </p> */}
        </div>

        <div className="contact-page-grid">
          {/* Left Column: Glassmorphic Contact Details */}
          <div className="contact-info-glass-card">
            <h2 className="info-card-company">Brooks Container Services</h2>

            <p className="info-card-desc">
              We’re here to help with your container needs. Whether you’re looking to buy, rent, or simply have questions about our investment plans, our team is ready to assist.
            </p>

            <div className="info-card-list">
              {/* Address Item */}
              <div className="info-card-item">
                <div className="info-card-icon-circle">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="info-card-text">
                  <span className="info-card-label">Office Address</span>
                  <span className="info-card-val">
                    1906, 19th floor, Citadel Tower, Business bay, Dubai
                  </span>
                </div>
              </div>

              {/* Email 1 Item */}
              <div className="info-card-item">
                <div className="info-card-icon-circle">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="info-card-text">
                  <span className="info-card-label">General Inquiry</span>
                  <a href="mailto:info@brookscontainer.com" className="info-card-link">
                    info@brookscontainer.com
                  </a>
                </div>
              </div>

              {/* Email 2 Item */}
              <div className="info-card-item">
                <div className="info-card-icon-circle">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="info-card-text">
                  <span className="info-card-label">Support Email</span>
                  <a href="mailto:contact@brookscontainer.com" className="info-card-link">
                    contact@brookscontainer.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Inline Scheduler Form Only */}
          <div className="contact-form-column">
            <MeetingScheduler onlyForm={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
